// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Text from "../Text.bs.js";
import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as Heading1 from "../Heading1.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Localization from "../../../../config/Localization.bs.js";
import * as ProductPanel from "./ProductPanel.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var wrapper = Curry._1(BsCss.style, {
      hd: BsCss.backgroundColor(Theme.Color.white),
      tl: {
        hd: BsCss.margin(BsCss.px(30)),
        tl: {
          hd: BsCss.media("(max-width: 768px)", {
                hd: BsCss.marginLeft(BsCss.px(20)),
                tl: {
                  hd: BsCss.marginRight(BsCss.px(20)),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: BsCss.media("(min-width: 1280px)", {
                  hd: BsCss.marginLeft(BsCss.px(0)),
                  tl: {
                    hd: BsCss.marginRight(BsCss.px(0)),
                    tl: /* [] */0
                  }
                }),
            tl: /* [] */0
          }
        }
      }
    });

var subTitle = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(16)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(25)),
        tl: {
          hd: BsCss.color(Theme.Color.midGrey),
          tl: {
            hd: BsCss.fontWeight("normal"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: {
                hd: BsCss.paddingBottom(BsCss.px(35)),
                tl: {
                  hd: BsCss.paddingTop(BsCss.px(10)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var productPanel = Curry._1(BsCss.style, {
      hd: BsCss.display("flex"),
      tl: {
        hd: BsCss.flexDirection("row"),
        tl: {
          hd: BsCss.justifyContent("flexStart"),
          tl: {
            hd: BsCss.media("(max-width: 1023px)", {
                  hd: BsCss.flexWrap("wrap"),
                  tl: {
                    hd: BsCss.justifyContent("center"),
                    tl: /* [] */0
                  }
                }),
            tl: /* [] */0
          }
        }
      }
    });

var Styles = {
  wrapper: wrapper,
  subTitle: subTitle,
  productPanel: productPanel
};

function WhoWeAreSection(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Heading1.make, {
                      children: "Who we are"
                    }),
                JsxRuntime.jsx($$Text.make, {
                      children: "Prezzee is a leading global eGift card platform with operations in North America, United Kingdom, Australia and New Zealand.",
                      className: subTitle
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ProductPanel.make, {
                              bodyText: "Every day gift giving made simple, personal and just right! Send a digital gift card from over 300 retail brands to friends and family around the world in seconds, " + (Belt_Option.getWithDefault(Localization.getLocalizedString("personalised"), "") + " with your own video!"),
                              brandText: "Prezzee",
                              productIconUrl: "/images/about/product/prezzee_classic.svg"
                            }),
                        JsxRuntime.jsx(ProductPanel.make, {
                              bodyText: "Reward teams, say thanks to clients and " + (Belt_Option.getWithDefault(Localization.getLocalizedString("incentivise"), "") + (" customers with fast,  " + (Belt_Option.getWithDefault(Localization.getLocalizedString("customised"), "") + " gift cards sent in bulk, in a few minutes. Our clients include QBE, HSBC, Coca-Cola and 4,000 more! Corporate gifting has never been easier."))),
                              brandText: "Prezzee",
                              titleText: "Business",
                              productIconUrl: "/images/about/product/prezzee_business.svg"
                            }),
                        JsxRuntime.jsx(ProductPanel.make, {
                              bodyText: "Seamlessly integrated via the Prezzee API, we help small and large businesses grow revenue and market share with a " + (Belt_Option.getWithDefault(Localization.getLocalizedString("customised"), "") + (" white-label marketplace featuring a  " + (Belt_Option.getWithDefault(Localization.getLocalizedString("catalogue"), "") + "  of 300+ eGift Cards."))),
                              brandText: "Prezzee",
                              titleText: "Marketplace",
                              productIconUrl: "/images/about/product/prezzee_marketplace.svg"
                            })
                      ],
                      className: productPanel
                    })
              ],
              className: wrapper
            });
}

var make = WhoWeAreSection;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
